/* assets/collection-slider.js */

(function () {
  function initCollectionSliders() {
    const sliders = document.querySelectorAll('.collection-slider-container');

    sliders.forEach((container) => {
      // Prevent double initialization
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      const track = container.querySelector('.collection-slider__track');
      const cards = container.querySelectorAll('.collection-slider__card');
      if (!track || cards.length === 0) return;

      const enableDesktop = container.dataset.desktopSlider === 'true';
      const enableMobile = container.dataset.mobileSlider === 'true';
      const autoRotateDesktop = container.dataset.autoRotateDesktop === 'true';
      const autoRotateMobile = container.dataset.autoRotateMobile === 'true';
      const speed = (parseFloat(container.dataset.speed) || 5) * 1000;

      const prevArrows = container.querySelectorAll('button[name="previous"]');
      const nextArrows = container.querySelectorAll('button[name="next"]');
      const dots = container.querySelectorAll('.collection-slider__dot');

      let autoplayTimer = null;
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let hasMoved = false;

      // Check active state based on viewport width
      function isSliderActive() {
        const isDesktop = window.innerWidth >= 768;
        return (isDesktop && enableDesktop) || (!isDesktop && enableMobile);
      }

      // Check auto rotate state based on viewport width
      function isAutoRotateActive() {
        const isDesktop = window.innerWidth >= 768;
        return isDesktop ? autoRotateDesktop : autoRotateMobile;
      }

      // Calculate scroll step based on visible cards
      function getScrollStep() {
        if (cards.length < 2) return track.clientWidth;
        const firstCard = cards[0];
        const nextCard = cards[1];
        const cardStep = nextCard.offsetLeft - firstCard.offsetLeft;
        const visibleWidth = track.clientWidth;
        const itemsPerPage = Math.max(1, Math.floor(visibleWidth / cardStep));
        return itemsPerPage * cardStep;
      }

      // Scroll to position
      function scrollToPosition(left) {
        track.scrollTo({
          left: left,
          behavior: 'smooth'
        });
      }

      // Navigation Actions
      function handlePrev() {
        if (!isSliderActive()) return;
        const isAtLeft = track.scrollLeft <= 5;
        if (isAtLeft && isAutoRotateActive()) {
          // Wrap to end
          scrollToPosition(track.scrollWidth - track.clientWidth);
        } else {
          scrollToPosition(track.scrollLeft - getScrollStep());
        }
      }

      // Next Action
      function handleNext() {
        if (!isSliderActive()) return;
        const isAtRight = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
        if (isAtRight && isAutoRotateActive()) {
          // Wrap to start
          scrollToPosition(0);
        } else {
          scrollToPosition(track.scrollLeft + getScrollStep());
        }
      }

      // Bind arrow buttons click events
      prevArrows.forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();
        handlePrev();
        resetAutoplay();
      }));

      nextArrows.forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();
        handleNext();
        resetAutoplay();
      }));

      // Bind dots click events
      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          if (!isSliderActive()) return;
          const index = parseInt(dot.dataset.index, 10);
          if (cards[index]) {
            scrollToPosition(cards[index].offsetLeft);
            resetAutoplay();
          }
        });
      });

      // Update Dot Navigation and Arrow Disabled states on scroll
      function updateSliderControls() {
        if (cards.length === 0) return;

        // 1. Calculate active card based on scroll position
        const currentScroll = track.scrollLeft;
        let activeIndex = 0;
        let minDiff = Infinity;

        cards.forEach((card, index) => {
          const diff = Math.abs(card.offsetLeft - currentScroll);
          if (diff < minDiff) {
            minDiff = diff;
            activeIndex = index;
          }
        });

        // 2. Update active dot class
        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.removeAttribute('aria-current');
          }
        });

        // 3. Update disabled states for arrows if loop is not active
        const isAtLeft = track.scrollLeft <= 5;
        const isAtRight = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;

        if (isAutoRotateActive()) {
          prevArrows.forEach((btn) => btn.removeAttribute('disabled'));
          nextArrows.forEach((btn) => btn.removeAttribute('disabled'));
        } else {
          prevArrows.forEach((btn) => {
            if (isAtLeft) btn.setAttribute('disabled', 'disabled');
            else btn.removeAttribute('disabled');
          });
          nextArrows.forEach((btn) => {
            if (isAtRight) btn.setAttribute('disabled', 'disabled');
            else btn.removeAttribute('disabled');
          });
        }
      }

      // Scroll Event Listener (Throttled using requestAnimationFrame)
      let scrollRunning = false;
      track.addEventListener('scroll', () => {
        if (!scrollRunning) {
          window.requestAnimationFrame(() => {
            updateSliderControls();
            scrollRunning = false;
          });
          scrollRunning = true;
        }
      });

      // Drag to scroll logic for desktop mouse users
      track.addEventListener('mousedown', (e) => {
        if (!isSliderActive() || window.innerWidth < 768) return;
        isDown = true;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        hasMoved = false;
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.5; // Drag speed multiplier
        if (Math.abs(x - startX) > 5) {
          // Only start drag mode after confirmed movement
          if (!hasMoved) {
            track.classList.add('is-dragging');
          }
          hasMoved = true;
          e.preventDefault();
        }
        track.scrollLeft = scrollLeft - walk;
      });

      track.addEventListener('mouseup', () => {
        isDown = false;
        track.classList.remove('is-dragging');
        // Reset hasMoved after click event fires so future clicks work
        setTimeout(() => { hasMoved = false; }, 0);
      });

      track.addEventListener('mouseleave', () => {
        isDown = false;
        track.classList.remove('is-dragging');
        hasMoved = false;
      });

      // Prevent link clicks during drag actions
      track.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (e) => {
          if (hasMoved) {
            e.preventDefault();
          }
        });
      });

      // Autoplay / Auto-Rotate functionality
      function startAutoplay() {
        if (!isAutoRotateActive() || !isSliderActive()) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
          const isAtRight = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
          if (isAtRight) {
            scrollToPosition(0);
          } else {
            scrollToPosition(track.scrollLeft + getScrollStep());
          }
        }, speed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      // Pause autoplay on mouse enter / touch start
      container.addEventListener('mouseenter', stopAutoplay);
      container.addEventListener('mouseleave', startAutoplay);
      container.addEventListener('touchstart', stopAutoplay, { passive: true });
      container.addEventListener('touchend', startAutoplay, { passive: true });

      // Handle screen resize/orientation change
      window.addEventListener('resize', () => {
        updateSliderControls();
        if (isSliderActive()) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });

      // Initial runs
      updateSliderControls();
      startAutoplay();
    });
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', initCollectionSliders);

  // Shopify Theme Editor reload support
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('section') || e.target.querySelector('.collection-slider-container')) {
      // Clear initialized attribute to allow re-running initialization
      const containers = e.target.querySelectorAll('.collection-slider-container');
      containers.forEach(container => {
        container.dataset.initialized = 'false';
      });
      initCollectionSliders();
    }
  });
})();
